module.exports = __webpack_public_path__ + "static/img/bottom4.15e0e259.png";